export default "__VITE_ASSET__CRfO3JyA__"